var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { FFTextInput, GBModalWrapper, GBTypography } from '@leapfinance/geebee-component-library';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { IconButton } from '@mui/material';
import { validRequiredUserName } from './AddSubAgentForm';
function ResetPassword(_a) {
    var onClose = _a.onClose, onReset = _a.onReset, userName = _a.userName, domain = _a.domain, loading = _a.loading, usernameFieldProps = _a.usernameFieldProps, modalDescription = _a.modalDescription;
    var formRef = useRef();
    var _b = __read(useState(true), 2), passwordVisible = _b[0], setPasswordVisible = _b[1];
    var _c = __read(useState(true), 2), confirmPasswordVisible = _c[0], setConfirmPasswordVisible = _c[1];
    return (React.createElement(GBModalWrapper, { headerProps: { title: 'Reset Password', onClose: onClose }, footerProps: {
            primaryCta: {
                title: 'Reset Password',
                buttonProps: {
                    onClick: function () { var _a; return (_a = formRef === null || formRef === void 0 ? void 0 : formRef.current) === null || _a === void 0 ? void 0 : _a.submit(); },
                    loading: loading
                }
            }
        }, variant: "small" },
        React.createElement(Form, { initialValues: { userName: userName }, onSubmit: function (values) {
                onReset === null || onReset === void 0 ? void 0 : onReset(values);
            }, validate: function (values) {
                if ((values === null || values === void 0 ? void 0 : values.confirmPassword) !== (values === null || values === void 0 ? void 0 : values.password)) {
                    return { confirmPassword: "Both password didn't match" };
                }
                return {};
            }, render: function (_a) {
                var form = _a.form;
                formRef.current = form;
                return (React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-3 lfc-p-4" },
                    modalDescription ? (typeof modalDescription === 'string' ? (React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-gbTokens-grey-A900" }, modalDescription)) : (modalDescription)) : null,
                    React.createElement(FFTextInput, __assign({ fieldProps: { name: 'userName', validate: validRequiredUserName }, componentProps: {
                            label: 'Username',
                            placeholder: 'Enter Username',
                            required: true,
                            InputProps: {
                                className: 'lfc-bg-white',
                                endAdornment: domain && React.createElement(GBTypography, { variant: "body3" },
                                    "@",
                                    domain)
                            },
                            disabled: true
                        } }, usernameFieldProps)),
                    React.createElement(FFTextInput, { fieldProps: {
                            name: 'password',
                            validate: function (value) { return (!value ? 'Required' : value.length < 6 ? 'Min 6 characters required' : false); }
                        }, componentProps: {
                            label: 'New Password',
                            placeholder: 'Enter new password',
                            required: true,
                            InputProps: {
                                className: 'lfc-bg-white',
                                endAdornment: (React.createElement(IconButton, { onClick: function () {
                                        setPasswordVisible(!passwordVisible);
                                    } }, !passwordVisible ? React.createElement(VisibilityIcon, null) : React.createElement(VisibilityOffIcon, null)))
                            },
                            type: passwordVisible ? 'text' : 'password',
                            helperText: 'Must be atleast 6 characters'
                        } }),
                    React.createElement(FFTextInput, { fieldProps: {
                            name: 'confirmPassword',
                            validate: function (value) { return (!value ? 'Required' : false); }
                        }, componentProps: {
                            label: 'Confirm Password',
                            placeholder: 'Enter Password',
                            required: true,
                            InputProps: {
                                className: 'lfc-bg-white',
                                endAdornment: (React.createElement(IconButton, { onClick: function () {
                                        setConfirmPasswordVisible(!confirmPasswordVisible);
                                    } }, !confirmPasswordVisible ? React.createElement(VisibilityIcon, null) : React.createElement(VisibilityOffIcon, null)))
                            },
                            type: confirmPasswordVisible ? 'text' : 'password'
                        } })));
            } })));
}
export default ResetPassword;
//# sourceMappingURL=ResetPassword.js.map